module.exports = __webpack_public_path__ + "static/media/S3N12-3.fbff1583.svg";